import { render, staticRenderFns } from "./InvoiceOrder.vue?vue&type=template&id=23327048&scoped=true"
import script from "./InvoiceOrder.vue?vue&type=script&lang=js"
export * from "./InvoiceOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23327048",
  null
  
)

export default component.exports